import React from "react";
import { Chip, Box } from "@mui/material";
import "./Tools.css";

const Tools = ({ visible, onClose, onToolSelect, selectedTools = [], extensionTools = [], customTools = [] }) => {
  const toolMapping = {
    "Search the Web": { icon: "pi pi-search", info: "Search the internet for information." },
    "Generate Picture": { icon: "pi pi-image", info: "Generate images based on text prompts." },
    "Search Documents": { icon: "pi pi-folder", info: "Search within uploaded documents." },
    "Graph Interpretation": { icon: "pi pi-chart-bar", info: "Generate Graph based on text prompts." },
    "Generate Presentation": { icon: "pi pi-file-export", info: "Generate a PowerPoint presentation." },
    "Generate Document": { icon: "pi pi-file-word", info: "Generate a Word document." },
    "Generate Spreadsheet": { icon: "pi pi-file-excel", info: "Generate an Excel spreadsheet." },
  };

  const customToolIconByType = {
    "postgresql": "pi pi-database",
    "blob-storage": "pi pi-cloud",
    "databricks": "pi pi-server",
    "rest-api": "pi pi-link",
  };

  // With an extension active, only show the tools the extension was created with.
  // Without an extension, show the full built-in catalog.
  const builtInNames = extensionTools.length > 0
    ? extensionTools
    : Object.keys(toolMapping);

  const builtInDetails = builtInNames.map((toolName) => {
    const fallback = { icon: "pi pi-question-circle", info: "No additional info available." };
    const mapped = toolMapping[toolName] || fallback;
    return { name: toolName, icon: mapped.icon, info: mapped.info };
  });

  const customDetails = (customTools || []).map((ct) => ({
    name: ct.name,
    icon: customToolIconByType[ct?.type] || "pi pi-cog",
    info: ct.description || `Custom ${ct.type || "tool"}`,
  }));

  // De-dupe by name in case a custom tool happens to share a built-in name
  const seen = new Set();
  const toolDetails = [...builtInDetails, ...customDetails].filter((t) => {
    if (seen.has(t.name)) return false;
    seen.add(t.name);
    return true;
  });

  const handleToolClick = (tool) => {
    onToolSelect(tool);
  };

  return (
    <Box className={`tools-container ${visible ? "visible" : ""}`}>
      <Box className="tools-list">
        {toolDetails.map((tool, index) => {
          const isSelected = selectedTools.some(t => t.name === tool.name);
          return (
            <Chip
              key={index}
              label={tool.name}
              icon={
                <i
                  className={`tool-icon ${tool.icon} ${isSelected ? "selected" : ""}`}
                  style={{ fontSize: "12px", marginLeft: "10px" }}
                />
              }
              onClick={() => handleToolClick(tool)}
              className={`tool-chip ${isSelected ? "selected" : ""}`}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default Tools;
